<template>
  <div class="order-ie-files">
    <fieldset>
      <legend class="d-flex">
        {{ $t('order.iefiles.title') }}
      </legend>

      <d-row>
        <d-col cols="6">
          <fieldset
            v-if="orderID"
            class="mb-3">
            <legend>
              {{ $t('order.iefiles.addingFileInitial') }}
            </legend>

            <label class="w-100 d-flex align-items-center">
              <file-input
                v-if="uploadInputVisibleInitial"
                :disabled="uploadInProgressInitial"
                :onChange="setFilesInitial"
                id="orderFile"
                :multiple="true" />
              <div
                v-if="uploadInProgressInitial"
                class="spinner-border spinner-border-sm ml-4"
                role="status"></div>
            </label>
          </fieldset>

          <d-alert
            v-if="!orderID"
            show
            theme="warning"
            class="text-center mb-0">
            {{ $t('order.iefiles.cannotAddFiles') }}
          </d-alert>

          <template v-if="orderID">
            <small
              v-for="(file, index) of orderFilesInitial"
              :key="'order-file-' + file.id + '-' + index"
              class="d-block mb-2">
              <a
                href="#"
                @click.prevent="downloadFile(file.id, file.file_url)">
                <div
                  v-if="downloadingFile === file.id"
                  class="spinner-border spinner-border-sm"
                  role="status"></div>
                {{ file.name }} <template v-if="file.name">({{ file.file }})</template><template v-else>{{ file.file }}</template>
              </a>
              <div
                v-if="deleteInProgressInitial === file.id"
                class="spinner-border spinner-border-sm"
                role="status"></div>
              <i
                v-if="deleteInProgressInitial !== file.id"
                class="material-icons text-danger"
                :style="'opacity:' + (deleteInProgressInitial ? '0.25' : '1') + '; cursor: pointer;'"
                @click.prevent="deleteFile(file.id, 'initial')">delete</i>

              <small class="d-block">
                {{ file.created_at }}
              </small>
            </small>
            <small
              v-if="!orderFilesInitial.length"
              class="d-block text-center">
              {{ $t('order.iefiles.noFilesToDisplay') }}
            </small>
          </template>
        </d-col>

        <d-col cols="6">
          <fieldset
            v-if="orderID"
            class="mb-3">
            <legend>
              {{ $t('order.iefiles.addingFileFinal') }}
            </legend>

            <label class="w-100 d-flex align-items-center">
              <file-input
                v-if="uploadInputVisibleFinal"
                :disabled="uploadInProgressFinal"
                :onChange="setFilesFinal"
                id="orderFile"
                :multiple="true" />
              <div
                v-if="uploadInProgressFinal"
                class="spinner-border spinner-border-sm ml-4"
                role="status"></div>
            </label>
          </fieldset>

          <d-alert
            v-if="!orderID"
            show
            theme="warning"
            class="text-center mb-0">
            {{ $t('order.iefiles.cannotAddFiles') }}
          </d-alert>

          <template v-if="orderID">
            <small
              v-for="(file, index) of orderFilesFinal"
              :key="'order-file-' + file.id + '-' + index"
              class="d-block mb-2">
              <a
                href="#"
                @click.prevent="downloadFile(file.id, file.file_url)">
                <div
                  v-if="downloadingFile === file.id"
                  class="spinner-border spinner-border-sm"
                  role="status"></div>
                {{ file.name }} <template v-if="file.name">({{ file.file }})</template><template v-else>{{ file.file }}</template>
              </a>
              <div
                v-if="deleteInProgressFinal === file.id"
                class="spinner-border spinner-border-sm"
                role="status"></div>
              <i
                v-if="deleteInProgressFinal !== file.id"
                class="material-icons text-danger"
                :style="'opacity:' + (deleteInProgressFinal ? '0.25' : '1') + '; cursor: pointer;'"
                @click.prevent="deleteFile(file.id, 'final')">delete</i>

              <small class="d-block">
                {{ file.created_at }}
              </small>
            </small>
            <small
              v-if="!orderFilesFinal.length"
              class="d-block text-center">
              {{ $t('order.iefiles.noFilesToDisplay') }}
            </small>
          </template>
        </d-col>
      </d-row>
    </fieldset>
  </div>
</template>

<script>
import Vue from 'vue';
import jsonToFormData from 'json-form-data';

export default {
  name: 'order-files',
  props: [
    'orderID',
    'orderFiles'
  ],
  computed: {
    orderFilesInitial () {
      return this.files.filter(file => file.type === 'INITIAL');
    },
    orderFilesFinal () {
      return this.files.filter(file => file.type === 'FINAL');
    }
  },
  data () {
    return {
      deleteInProgressFinal: false,
      deleteInProgressInitial: false,
      downloadingFile: false,
      files: [],
      removingFileFinal: false,
      removingFileInitial: false,
      uploadInputVisibleInitial: true,
      uploadInputVisibleFinal: true,
      uploadInProgressInitial: false,
      uploadInProgressFinal: false,
      initial: {
        files: null,
        type: 'INITIAL'
      },
      final: {
        files: null,
        type: 'FINAL'
      },
      token: ''
    };
  },
  mounted () {
    this.files = JSON.parse(JSON.stringify(this.orderFiles));
  },
  methods: {
    uploadFile (fileIndex, formType) {
      let uploadData = {
        order_id: this.orderID,
        type: this[formType].type,
        file: this[formType].files[fileIndex]
      };

      if (formType === 'initial') {
        this.uploadInProgressInitial = true;
      } else {
        this.uploadInProgressFinal = true;
      }

      if (this.token) {
        uploadData.token = this.token;
      }

      this.$http.request({
        method: 'POST',
        url: '/orders/ie-files/store',
        headers: {
          'Content-Type': undefined
        },
        transformRequest (data) {
          let dataToSend = jsonToFormData(data);
          return dataToSend;
        },
        data: uploadData
      }).then((response) => {
        if (response.data.success) {
          this.files.push(response.data.item);
        }

        if (fileIndex === this[formType].files.length - 1) {
          this[formType].files = null;

          if (formType === 'initial') {
            this.uploadInProgressInitial = false;
          } else {
            this.uploadInProgressFinal = false;
          }

          if (formType === 'initial') {
            this.uploadInputVisibleInitial = false;
          } else {
            this.uploadInputVisibleFinal = false;
          }

          Vue.nextTick(() => {
            if (formType === 'initial') {
              this.uploadInputVisibleInitial = true;
            } else {
              this.uploadInputVisibleFinal = true;
            }
          });
        } else {
          fileIndex++;
          this.uploadFile(fileIndex, formType);
        }
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('order.iefiles.uploadError'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });

        if (formType === 'initial') {
          this.uploadInProgressInitial = false;
        } else {
          this.uploadInProgressFinal = false;
        }
      });
    },
    downloadFile (fileID, fileURL) {
      if (this.downloadingFile) {
        return;
      }

      this.downloadingFile = fileID;

      this.$http.post(fileURL, null, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        let filename = response.request.getResponseHeader('content-disposition').split('filename=')[1].split(';')[0];
        link.setAttribute('download', filename.replace(/"/gmi, ''));
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.downloadingFile = false;
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('ui.errorOccuredDuringDownload'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.downloadingFile = false;
      });
    },
    deleteFile (fileID, formType) {
      if (
        (formType === 'initial' && this.deleteInProgressInitial) ||
        (formType === 'final' && this.deleteInProgressFinal)
      ) {
        return;
      }

      Vue.swal({
        title: this.$t('order.iefiles.removeFileTitle'),
        text: this.$t('order.iefiles.removeFileDesc'),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: this.$t('order.iefiles.deleteFile'),
        cancelButtonText: this.$t('ui.cancel')
      }).then((result) => {
        if (result.value) {
          if (formType === 'initial') {
            this.deleteInProgressInitial = fileID;
          } else {
            this.deleteInProgressFinal = fileID;
          }

          this.$http.post('/orders/ie-files/delete/' + fileID).then(response => {
            if (response.data.success) {
              Vue.swal({
                title: this.$t('purchase.fileDeletedTitle'),
                html: this.$t('purchase.fileDeletedDesc'),
                type: 'success',
                confirmButtonText: this.$t('ui.ok'),
                buttonsStyling: true
              });

              this.files = this.files.filter(file => file.id !== fileID);

              if (formType === 'initial') {
                this.deleteInProgressInitial = false;
              } else {
                this.deleteInProgressFinal = false;
              }
            } else {
              Vue.swal({
                title: this.$t('ui.errorOccured'),
                html: this.$t('ui.tryAgain'),
                type: 'warning',
                confirmButtonText: this.$t('ui.ok'),
                buttonsStyling: true
              });

              if (formType === 'initial') {
                this.deleteInProgressInitial = false;
              } else {
                this.deleteInProgressFinal = false;
              }
            }
          }).catch(error => {
            console.log(error);
            Vue.swal({
              title: this.$t('ui.errorOccured'),
              html: this.$t('ui.tryAgain'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });

            if (formType === 'initial') {
              this.deleteInProgressInitial = false;
            } else {
              this.deleteInProgressFinal = false;
            }
          });
        }
      });
    },
    setFilesInitial (event) {
      this.setFiles(event, 'initial');
    },
    setFilesFinal (event) {
      this.setFiles(event, 'final');
    },
    setFiles (event, formType) {
      this[formType].files = event.target.files;

      if (this[formType].files) {
        this.uploadInProgress = true;
        this.uploadFile(0, formType);
      }
    }
  }
}
</script>

<style lang="scss">
.order-ie-files {
  fieldset {
    border: 1px solid #ddd;
    margin-top: 10px;
    padding: 0 20px 15px 20px;

    legend {
      font-size: 16px;
      padding: 0 10px;
    }
  }
}
</style>
